function bindCaddySizeGuides(root = document) {
  root.querySelectorAll('[data-caddy-size-guide-open]').forEach((trigger) => {
    if (trigger.dataset.caddySizeGuideBound === 'true') return;

    const dialogId = trigger.getAttribute('aria-controls');
    const dialog = dialogId ? document.getElementById(dialogId) : null;
    if (!(dialog instanceof HTMLDialogElement)) return;

    const closeButton = dialog.querySelector('[data-caddy-size-guide-close]');
    let returnFocus = trigger;
    trigger.dataset.caddySizeGuideBound = 'true';

    trigger.addEventListener('click', () => {
      returnFocus = document.activeElement instanceof HTMLElement ? document.activeElement : trigger;
      if (!dialog.open) dialog.showModal();
    });

    closeButton?.addEventListener('click', () => dialog.close());

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });

    dialog.addEventListener('keydown', (event) => {
      if (event.key !== 'Tab') return;

      const focusable = [...dialog.querySelectorAll(
        'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )].filter((element) => element.getClientRects().length > 0);
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    dialog.addEventListener('close', () => {
      if (document.contains(returnFocus)) returnFocus.focus();
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => bindCaddySizeGuides(), { once: true });
} else {
  bindCaddySizeGuides();
}

document.addEventListener('shopify:section:load', (event) => bindCaddySizeGuides(event.target));
